export function transformOnValidJSONString(str) {
  try {
    JSON.parse(str)
  } catch (error) {
    return str
  }

  return JSON.parse(str)
}
